import { FC, ReactNode } from 'react';
import { Box, SxProps, Theme, useTheme } from '@mui/material';

interface Props {
  children?: ReactNode;
  sx?: SxProps<Theme>;
}

const ActionBar: FC<Props> = ({ children, sx }) => {
  const theme = useTheme();

  return (
    <Box
      sx={{
        display: 'flex',
        height: '56px',
        alignItems: 'center',
        backgroundColor:
          theme.palette.mode === 'light'
            ? theme.palette.background.paper
            : 'rgba(255, 255, 255, 0.1)',
        p: theme.spacing(1),
        borderRadius: theme.spacing(1),
        ...sx,
      }}
    >
      {children}
    </Box>
  );
};

export default ActionBar;
